import React from 'react'

const Unauthorized = () => {
  return (
    <h1 className='unauthorized'>You don't have the authorization to access the page you requested</h1>
  )
}

export default Unauthorized